import { useInfiniteQuery } from '@tanstack/react-query'
import {
	type HttpGetExperienceVettingCategoryFormatsParams,
	httpGetExperienceVettingCategoryFormats
} from '@/features/experience-vetting/http/experience-vetting.http'
import { infiniteQueryFetchNextPage } from '@/helpers/utils'
import { QUERY_KEYS } from '@/query-client'

export const useGetExperienceVettingCategoryFormats = (
	promiseArgs: Omit<HttpGetExperienceVettingCategoryFormatsParams, 'page'>,
	options?: { enabled?: boolean }
) => {
	const query = useInfiniteQuery({
		queryKey: [QUERY_KEYS.EXPERIENCE_VETTING_CATEGORY_FORMATS, promiseArgs],
		queryFn: ({ pageParam = 1 }) =>
			httpGetExperienceVettingCategoryFormats({
				...promiseArgs,
				page: pageParam
			}),
		...options,
		initialPageParam: 1,
		getNextPageParam: ({ meta }) =>
			meta.currentPage < meta.lastPage ? meta.currentPage + 1 : undefined
	})

	return {
		...query,
		fetchNextPage: () => infiniteQueryFetchNextPage(query),
		remappedData: query.data?.pages[0]?.data?.length
			? query.data.pages.flatMap((page) => page.data)
			: []
	}
}
